export default {
    props: {
        expand: {
            type: Boolean,
            kComposite: 'expand'
        }, 
        name: {
            type: String,
            kComposite: 'name'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotColumn/Columns.js